module.exports = require("core-js-pure/features/reflect/construct");